// extracted by mini-css-extract-plugin
module.exports = {"inputHome":"formHome_inputHome__10SpR","buttonHome":"formHome_buttonHome__WiY50","formHome":"formHome_formHome__UR_gk","labelHome":"formHome_labelHome__3Qz_h"};